exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".empty-search-results__no-search-wrapper__1vg37{-ms-flex-positive:1;flex-grow:1;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;padding:36px 0 54px;color:-wix-colors-buttonsAndLinksColor;opacity:.5}.empty-search-results__no-search-icon__2AZs7{margin-bottom:15px;heigth:37px;font-size:36px}.empty-search-results__no-search-icon__2AZs7 path{fill:-wix-colors-buttonsAndLinksColor}.empty-search-results__no-search-text__3ofiu{font-size:16px}", ""]);

// exports
exports.locals = {
	"no-search-wrapper": "empty-search-results__no-search-wrapper__1vg37",
	"noSearchWrapper": "empty-search-results__no-search-wrapper__1vg37",
	"no-search-icon": "empty-search-results__no-search-icon__2AZs7",
	"noSearchIcon": "empty-search-results__no-search-icon__2AZs7",
	"no-search-text": "empty-search-results__no-search-text__3ofiu",
	"noSearchText": "empty-search-results__no-search-text__3ofiu"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":false,"importLoaders":1,"camelCase":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./~/stylus-loader?{"sourceMap":true,"resolve":true,"define":{}}!./src/widget/components/empty-search-results/empty-search-results.styl
// module id = 2910
// module chunks = 1